import Alpine from "alpinejs";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const initHomeLineUpTruckAnimation = () => {
  Alpine.data("homeLineUpTruckAnimation", () => {
    return {
      init() {
        const root = this.$el as HTMLElement;
        const trigger =
          root.closest<HTMLElement>("[data-lineup-title-animation]") || root;
        const prefersReducedMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)"
        ).matches;

        root.dataset.spriteState = "paused";
        gsap.set(root, {
          autoAlpha: 0,
          scale: 0.94,
          yPercent: 8,
          transformOrigin: "50% 100%",
        });

        if (prefersReducedMotion) {
          gsap.set(root, {
            autoAlpha: 1,
            scale: 1,
            yPercent: 0,
          });
          return;
        }

        const showTimeline = gsap.timeline({
          scrollTrigger: {
            trigger,
            start: "top 75%",
            once: true,
          },
        });

        showTimeline.to(root, {
          autoAlpha: 1,
          scale: 1,
          yPercent: 0,
          duration: 0.8,
          ease: "back.out(1.2)",
          delay: 0.1,
        });
        showTimeline.call(
          () => {
            root.dataset.spriteState = "playing";
          },
          [],
          0.35
        );
      },
    };
  });
};
